<template>
  <div class="pdf-embed-viewer">
    <div v-if="isLoading" class="loader">Loading PDF...</div>
    <embed
      v-if="pdfUrl"
      :src="pdfUrl + '#toolbar=0&navpanes=0&scrollbar=0'"
      type="application/pdf"
      width="100%"
      height="100%"
      @load="handleLoad"
    />
    <div v-if="hasError" class="error-message">
      Failed to load PDF. Please try again later.
    </div>
  </div>
</template>

<script>
export default {
  name: 'PdfEmbedViewer',
  props: {
    pdfUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: true,
      hasError: false,
      loadTimeout: null,
    };
  },
  mounted() {
    this.loadTimeout = setTimeout(() => {
      if (this.isLoading) {
        this.hasError = true;
        this.isLoading = false;
      }
    }, 10000); // 10 seconds timeout
  },
  beforeDestroy() {
    clearTimeout(this.loadTimeout);
  },
  methods: {
    handleLoad() {
      this.isLoading = false;
      clearTimeout(this.loadTimeout);
    },
  },
};
</script>

<style scoped>
.pdf-embed-viewer {
  position: relative;
  width: 100%;
  height: 100%;
}
.loader,
.error-message {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 18px;
  color: #555;
}
.error-message {
  color: red;
}
</style>
